/* eslint-disable no-unused-vars */
export enum LanguageCodes {
  FR = 'fra',
  EN = 'eng',
}
